/**
 * Réduit une photo dans le navigateur avant l'envoi (Yros/Kavero#488) : une
 * photo de téléphone dépasse vite les 2 Mo qu'acceptent le proxy et Odoo.
 *
 * L'image est redessinée au plus `coteMax` pixels de côté et rendue en JPEG,
 * sur fond blanc : un PNG transparent passerait sinon au noir.
 */
export const COTE_MAX = 1024;
export const QUALITE_JPEG = 0.85;

export function reduirePhoto(fichier, { coteMax = COTE_MAX, qualite = QUALITE_JPEG } = {}) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(fichier);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      const echelle = Math.min(1, coteMax / Math.max(image.naturalWidth, image.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * echelle));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * echelle));
      const contexte = canvas.getContext('2d');
      if (!contexte) {
        reject(new Error('Canvas indisponible'));
        return;
      }
      contexte.fillStyle = '#fff';
      contexte.fillRect(0, 0, canvas.width, canvas.height);
      contexte.drawImage(image, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', qualite));
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Image illisible'));
    };
    image.src = url;
  });
}
